import { 
  Avatar, 
  Box, 
  Flex, 
  HStack, 
  Heading, 
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiMenu, FiLogOut, FiChevronDown } from "react-icons/fi";
import { logOut } from "../services/authService";
import LanguageSwitcher from "./LanguageSwitcher";
import { useGetUserProfile } from "../services/userProfileService";
import { useGetPlanInfo } from "../services/planService";
import { useLocation } from "react-router-dom";
import { formatRoleName } from "../utils/roleFormatter";

const NavBar = ({ pic, sidebarOpen, setSidebarOpen, setOpen, open }) => {
  const { pathname } = useLocation();
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  
  // Use the hook to fetch user profile
  const { profileData: userData, profileIsLoading: loading } = useGetUserProfile({ enabled: true });
  
  // Use the hook to fetch plan info for customer details
  const { planInfo: planData, planInfoIsLoading: planLoading } = useGetPlanInfo({ enabled: true });

  // Extract customer name and role from plan info
  const customerName = planData?.customer_name || userData?.name || "Admin User";
  const customerRole = planData?.customer_role || userData?.company || "Administrator";

  // Don't render navbar on login or reset password pages
  if (pathname === '/login' || pathname === '/reset-password') {
    return null;
  }

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      p={6}
      borderBottom="1px solid"
      borderColor={borderColor}
      bg={bgColor}
      w="100%"
      pos="relative"
      shadow="sm"
    >
      {/* Left Section */}
      <HStack spacing={4}>
        <IconButton
          display={{ base: "flex", lg: "none" }}
          icon={<FiMenu />}
          variant="ghost"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open sidebar"
          color="gray.600"
          _hover={{ bg: "gray.100" }}
        />
        <Heading fontSize="lg" fontWeight="600" color="gray.900">
          
        </Heading>
      </HStack>

      {/* Right Section */}
      <HStack spacing={4}>
        <LanguageSwitcher />
        
        <VStack spacing={0} align="end" display={{ base: "none", md: "flex" }}>
          <Text fontSize="sm" fontWeight="500" color="gray.900">
            {planLoading || loading ? "Loading..." : customerName}
          </Text>
          <Text fontSize="xs" color="gray.500">
            {planLoading || loading ? "Loading..." : formatRoleName(customerRole)}
          </Text>
        </VStack>

        <Menu>
          <MenuButton
            as={Flex}
            alignItems="center"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
            p={2}
            borderRadius="8px"
            transition="all 0.2s"
          >
            <Avatar 
              size="sm" 
              name={customerName} 
              bg="blue.500"
              color="white"
              mr={2}
            />
            <FiChevronDown color="#6B7280" />
          </MenuButton>
          <MenuList
            border="1px solid"
            borderColor="gray.200"
            shadow="lg"
            borderRadius="12px"
            py={2}
          >
            <MenuItem
              icon={<FiLogOut />}
              onClick={logOut}
              _hover={{ bg: "gray.50" }}
              borderRadius="8px"
              mx={2}
              color="red.600"
            >
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
      </HStack>
      
    </Flex>
  );
};

export default NavBar;
